import { useState } from 'react';
import { useCenter } from './useCenter';

type FilterState = {
  zone?: string;
  district?: string;
  status?: string;
  center_type?: string;
};

type SortConfig = {
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
};

export const useCenterFilters = () => {
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [filters, setFilters] = useState<FilterState>({});
  const [tempFilters, setTempFilters] = useState<FilterState>({});
  const [sortConfig, setSortConfig] = useState<SortConfig>({});

  const { getCenterState, paginationData } = useCenter({
    page: pageNumber,
    size: recordsPerPage,
    search,
    ...filters,
    ...sortConfig,
  });

  const handleSearchChange = (text: string) => {
    setSearch(text);
    setPageNumber(1);
  };

  const handlePageChange = (page: number, pageSize?: number) => {
    setPageNumber(page);
    if (pageSize) {
      setRecordsPerPage(pageSize);
    }
  };

  const handleFilterChange = (filterName: string, value: any) => {
    setTempFilters(prev => ({
      ...prev,
      [filterName]: value?.value
    }));
  };

  const handleSortChange = (sortBy: string, order: 'asc' | 'desc') => {
    const newOrder = sortConfig.sort_by === sortBy && sortConfig.sort_order === 'asc' ? 'desc' : 'asc';
    setSortConfig({
      sort_by: sortBy,
      sort_order: newOrder
    });
    setPageNumber(1);
  };

  const handleResetFilters = () => {
    const emptyFilters = {
      zone: undefined,
      district: undefined,
      status: undefined,
      center_type: undefined,
    };
    setFilters(emptyFilters);
    setTempFilters(emptyFilters);
    setSortConfig({
      sort_by: undefined,
      sort_order: undefined,
    });
    setPageNumber(1);
  };

  const handleApplyFilters = () => {
    setFilters(tempFilters);
    setPageNumber(1);
  };

  return {
    getCenterState,
    paginationData,
    search,
    pageNumber,
    recordsPerPage,
    filters,
    tempFilters,
    sortConfig,
    handleSearchChange,
    handlePageChange,
    handleFilterChange,
    handleSortChange,
    handleResetFilters,
    handleApplyFilters,
    setTempFilters,
    setRecordsPerPage,
  };
}; 